import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manage-request',
  standalone: true,
  imports: [],
  templateUrl: './manage-request.component.html',
  styleUrl: './manage-request.component.scss'
})
export class ManageRequestComponent {
  title = 'Manage Requests';

  constructor(private route: Router) {}

  navigate(url: string) {
    this.route.navigate([url]);
  }
}
